export const environment = {
  production: false,
  authorizationServiceUrl: 'https://us-central1-starkey-engage-develop.cloudfunctions.net',
  appName: 'phonesupport-develop'
};
